import React, { useState, useEffect } from "react";
import { Icon } from '@iconify/react/dist/iconify.js';
import axios from 'axios'; 
import { toast, ToastContainer } from 'react-toastify'; 
import 'react-toastify/dist/ReactToastify.css'; 
import { useNavigate } from "react-router-dom";
import { getMediaUrl } from "../utils/uploadService";
import ComplaintUploadWithImagePreviewList from "./child/ComplaintUploadWithImagePreviewList";
const ComplainFormPageCloseUpdate = ({ complainId }) => {
  const API_BASE_URL = process.env.REACT_APP_BE_API_URL;
  const storedUser = JSON.parse(localStorage.getItem('user'));
  const authUserId = storedUser._id;
  const navigate = useNavigate();

  const [formDataForest, setFormDataForest] = useState({ 
    complaintAction: 'Resolve',
    closeRemarks: '',
    reopenRemarks: ''
  });
  
  const [officerChecklist, setOfficerChecklist] = useState({
    DFO: false,
    CF: false,
    CCF: false,
    DG: false,
    SO_FOREST: false,
    AS_ADMIN: false,
    AS_TECH: false,
    AS_PMAE: false,
    GIS_LAB_MANAGER: false,
    DS_WILDLIFE: false
  });
  const [reopenOfficers, setReopenOfficers] = useState([]);
  const [selectedOfficerId, setSelectedOfficerId] = useState("");
  const [isLoadingOfficers, setIsLoadingOfficers] = useState(false);
  // Optional attachment(s) uploaded alongside the re-open remarks.
  const [reopenMediaUrls, setReopenMediaUrls] = useState([]);
  
  const [formData, setFormData] = useState({
    dept_id: "",
    dept_name: "",
    district_id: "",
    complaint_district_name: "",
    complaint_number: "",
    complaint_nature_id: "",
    complaint_nature_name: "",
    complaint_nearby_place: "",
    complaint_detail: "",
    complainant_name: "",
    complainant_address: "",
    complainant_contact_no: "",
    complainant_email: "",
    complaint_time: "",
    complaint_additional_remarks: "",
    complainant_phone_secondry: "",
    other_nature: "",
    received_by: "",
    status: "Open",
    priority_level: "",
    cnic: "",
    complaint_source: "",
    complainant_city: "",
    complainant_tehsil: "",
    complainant_district: "",
    complaint_city: "",
    complaint_tehsil: "",
    complaint_district: "",
    complaint_address: "",
    media_array: [],
    statusHistory: [],
  });

  const [isLoading, setIsLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [, setShowAttachmentsModal] = useState(false);
  const [ setShowClosingEvidenceModal] = useState(false);

  const officerConfig = {
    DFO: { label: "DCF", icon: "mdi:account-tie", color: "primary" },
    CF: { label: "CF", icon: "mdi:account-tie-hat", color: "success" },
    CCF: { label: "CCF", icon: "mdi:account-tie-voice", color: "warning" },
    DG: { label: "DG", icon: "mdi:account-tie-woman", color: "danger" },
    SO_FOREST: { label: "SO Forest", icon: "mdi:forest", color: "success" },
    AS_ADMIN: { label: "AS Admin", icon: "mdi:office-building", color: "info" },
    AS_TECH: { label: "AS Tech", icon: "mdi:cogs", color: "secondary" },
    AS_PMAE: { label: "AS PM&E", icon: "mdi:chart-bar", color: "primary" },
    GIS_LAB_MANAGER: { label: "Manager GIS Lab", icon: "mdi:map-marker-radius", color: "success" },
    DS_WILDLIFE: { label: "DS Wildlife", icon: "mdi:paw", color: "success" }
  };

  useEffect(() => {
    const fetchComplaintData = async () => {
      try {
        const token = localStorage.getItem("token");
        const response = await axios.get(`${API_BASE_URL}/backend/complaints/${complainId}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (response.data.status) {
          const complaintData = response.data.data;
          setFormData({
            dept_id: complaintData.dept_id?._id || "",
            dept_name: complaintData.dept_id?.name || "",
            complaint_number: complaintData.complaint_number || "",
            district_id: complaintData.complaint_district_id?._id || "",
            complaint_nature_id: complaintData.complaint_nature_id?._id || "",
            complaint_nature_name: complaintData.complaint_nature_id?.name || "",
            complaint_nearby_place: complaintData.near_by_place || "",
            complaint_detail: complaintData.complaint_detail || "",
            complainant_name: complaintData.complainant_name || "",
            complainant_address: complaintData.complainant_address || "",
            complainant_contact_no: complaintData.complainant_contact_no || "",
            complainant_email: complaintData.complainant_email || "",
            complaint_time: complaintData.time_of_call || "",
            complaint_additional_remarks: complaintData.remarks || "",
            complainant_phone_secondry: complaintData.complainant_contact_no_sec || "",
            other_nature: complaintData.other_nature || "",
            received_by: `${complaintData.received_by?.first_name || ''} ${complaintData.received_by?.last_name || ''}`.trim() || "",
            status: complaintData.status || "Open",
            priority_level: complaintData.priority_level || "",
            cnic: complaintData.complainant_cnic || "",
            complaint_source: complaintData.complaint_source || "",
            complainant_city: complaintData.complainant_city_id?.name || "",
            complainant_tehsil: complaintData.complainant_tehsil_id?.name || "",
            complainant_district: complaintData.complainant_district_id?.name || "",
            complaint_city: complaintData.complaint_city_id?.name || "",
            complaint_tehsil: complaintData.complaint_tehsil_id?.name || "",
            complaint_district: complaintData.complaint_district_id?.name || "",
            complaint_address: complaintData.complaint_address || "",
            lat: complaintData.lat || "",
            long: complaintData.long || "",
            assigned_to: `${complaintData.assigned_to?.first_name || ''} ${complaintData.assigned_to?.last_name || ''}`.trim() || "",
            dispatched_time: complaintData.dispatched_time || "",
            referred_by: complaintData.referred_by || "",
            dfo_remarks: complaintData.dfo_remarks || "",
            cancel_reason: complaintData.cancel_reason || "",
            media_array: complaintData.media_array || [],
            statusHistory: complaintData.statusHistory || [],
          });
        }
      } catch (error) {
        toast.error("Failed to fetch complaint data.");
        console.error("Error fetching complaint data:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchComplaintData();
  }, [API_BASE_URL, complainId, authUserId]);

  const handleChecklistChange = (selectedOfficer) => {
    setSelectedOfficerId("");
    setReopenOfficers([]);
    setOfficerChecklist(prev => {
      const newChecklist = Object.keys(prev).reduce((acc, officer) => {
        acc[officer] = false;
        return acc;
      }, {});
      newChecklist[selectedOfficer] = !prev[selectedOfficer];
      return newChecklist;
    });
  };

  useEffect(() => {
    const selectedHierarchyType = officerChecklist.DFO
      ? "DCF"
      : officerChecklist.CF
        ? "CF"
        : officerChecklist.CCF
          ? "CCF"
          : null;

    if (!selectedHierarchyType) return;

    const fetchReopenOfficers = async () => {
      setIsLoadingOfficers(true);
      try {
        const token = localStorage.getItem("token");
        const response = await axios.get(
          `${API_BASE_URL}/backend/complaints/reopen-officers/${selectedHierarchyType}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        setReopenOfficers(response.data?.data || []);
      } catch (error) {
        setReopenOfficers([]);
        toast.error(error.response?.data?.message || `Failed to fetch ${selectedHierarchyType} officers.`);
      } finally {
        setIsLoadingOfficers(false);
      }
    };

    fetchReopenOfficers();
  }, [API_BASE_URL, officerChecklist.DFO, officerChecklist.CF, officerChecklist.CCF]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormDataForest(prev => ({ ...prev, [name]: value }));
  };

  const getPriorityClasses = (priority) => {
    switch (priority) {
      case "Low":
        return "bg-info-focus text-info-600";
      case "Medium":
        return "bg-success-focus text-success-600";
      case "High":
        return "bg-warning-focus text-warning-600";
      case "Critical":
        return "bg-danger-focus text-danger-600";
      default:
        return "bg-secondary text-secondary-600";
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (isSubmitting) return;

    setIsSubmitting(true);

    const token = localStorage.getItem("token");
    if (!token) {
      toast.error("Authentication token not found. Please login again.");
      setIsSubmitting(false);
      return;
    }

    if (formDataForest.complaintAction === 'Resolve') {
      if (!formDataForest.closeRemarks) {
        toast.error("Please provide remarks for resolving the complaint!");
        setIsSubmitting(false);
        return;
      }

      try {
        const statusData = {
          id: complainId,
          feedback_text: formDataForest.closeRemarks,
          status: "Resolved",
        };

        const response = await axios.post(
          `${API_BASE_URL}/backend/complaints/complainant-feedback`,
          statusData,
          {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}`,
            },
            timeout: 10000,
          }
        );

        if (response.data.status) {
          toast.success("Complaint resolved successfully!");
          navigate("/closed/list", { state: { showToast: true } });
        } else {
          toast.error(response.data.message || "Failed to resolve complaint.");
        }
      } catch (postError) {
        toast.error(postError.response?.data?.message || "Failed to resolve complaint.");
        console.error("Error resolving complaint:", postError);
      } finally {
        setIsSubmitting(false);
      }
    } else if (formDataForest.complaintAction === 'Re-Open') {
      if (!formDataForest.reopenRemarks) {
        toast.error("Please provide remarks for re-opening the complaint!");
        setIsSubmitting(false);
        return;
      }

      const selectedOfficers = Object.values(officerChecklist).filter(Boolean);
      if (selectedOfficers.length === 0) {
        toast.error("Please select one officer for the checklist!");
        setIsSubmitting(false);
        return;
      }

      if (selectedOfficers.length > 1) {
        toast.error("Please select only one officer at a time!");
        setIsSubmitting(false);
        return;
      }

      const isHierarchyOfficer = officerChecklist.DFO || officerChecklist.CF || officerChecklist.CCF;
      if (isHierarchyOfficer && !selectedOfficerId) {
        toast.error("Please select an officer from the dropdown!");
        setIsSubmitting(false);
        return;
      }

      try {
        const statusData = {
          complaintId: complainId,
          reason: formDataForest.reopenRemarks,
          selectedOfficerId,
          media_array: reopenMediaUrls, // optional attachment(s)
          ...officerChecklist
        };

        const response = await axios.post(
          `${API_BASE_URL}/backend/complaints/repen-complaint`,
          statusData,
          {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}`,
            },
            timeout: 10000,
          }
        );

        if (response.data.status) {
          toast.success("Complaint re-opened successfully!");
          navigate("/closed/list", { state: { showToast: true } });
        } else {
          toast.error(response.data.message || "Failed to re-open complaint.");
        }
      } catch (postError) {
        toast.error(postError.response?.data?.message || "Failed to re-open complaint.");
        console.error("Error re-opening complaint:", postError);
      } finally {
        setIsSubmitting(false);
      }
    }
  };

  // Handler for Back button
  const handleBack = () => {
    navigate("/closed/list");
  };

  // Handler for Export PDF button
  const handleExportPDF = () => {
    window.open(`/complains/view/${complainId}`, '_blank');
  };

  if (isLoading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: "100vh" }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  const latestStatusHistory = [...formData.statusHistory]
    .reverse()
    .find((entry) => entry.status === 'Closed') || null;

  return (
    <div className="col-lg-12 col-md-12 col-sm-12">
      <ToastContainer />
      
      <div className="text-center"></div>
      
      <div className="card-body py-10">
        {/* Buttons Section */}
        <div className="d-flex justify-content-between mb-4">
          <button
            className="btn btn-success-500 btn-md px-6 py-6 radius-8"
            onClick={handleBack}
          >
            <Icon icon="mdi:arrow-left" className="me-2" />
            Back
          </button>
          <button
            className="btn btn-success-900 btn-md px-6 py-6 radius-8"
            onClick={handleExportPDF}
          >
            Export PDF
          </button>
        </div>
        {/* End Buttons Section */}

        <div className="row justify-content-center">
          <div className="col-lg-12">
            <div className="shadow-4 border radius-8">
              <div className="p-20 border-bottom fs-5">
                <div className="row justify-content-between g-3">
                  <div className="col-sm-6">
                    <h4 className="mb-20">{formData.complaint_number} <span className={`px-3 py-1 rounded-pill fw-semibold text-xl ${getPriorityClasses(formData.priority_level)}`}>
                      {formData.priority_level || 'No Data Found'}
                    </span></h4>
                    <div className="space-y-2">
                      {[
                        { label: 'Complaint Time', icon: 'mdi:clock-outline', value: formData.complaint_time },
                        { label: 'Department', icon: 'mdi:office-building', value: formData.dept_name },
                        {
                          label: 'Source of Complaint',
                          icon: 'mdi:source-branch',
                          value: (
                            <>
                              {formData.complaint_source}
                              {formData.complaint_source === 'Public Form' && formData.media_array?.length > 0 && (
                                <button
                                  className="btn btn-sm btn-success-600 mx-20"
                                  onClick={() => setShowAttachmentsModal(true)}
                                  data-bs-toggle="modal"
                                  data-bs-target="#attachmentsModal"
                                >
                                  Show Evidence
                                </button>
                              )}
                            </>
                          )
                        },
                        {
                          label: 'Nature of Complaint',
                          icon: 'mdi:alert-circle',
                          value: (
                            <>
                              {formData.complaint_nature_name}
                              {formData.complaint_nature_name === 'Other' && formData.other_nature && (
                                <span className="ms-2 text-muted fst-italic">({formData.other_nature})</span>
                              )}
                            </>
                          )
                        },
                      ].map(({ label, icon, value }, index) => (
                        <div key={index} className="d-flex justify-content-between">
                          <span className="text-success d-flex align-items-center gap-1 col-4 fw-bold">
                            <Icon icon={icon} /> {label}
                          </span>
                          <span className="col-1">:</span>
                          <span className="col-7 text-decoration-underline">{value}</span>
                        </div>
                      ))}
                    </div>
                  </div>

                  <div className="col-sm-6 space-y-2">
                    {[
                      { label: 'Nearby Place', icon: 'mdi:map-marker', value: formData.complaint_nearby_place },
                      { label: 'Complaint Tehsil', icon: 'mdi:map', value: formData.complaint_tehsil },
                      { label: 'Complaint District', icon: 'mdi:map-outline', value: formData.complaint_district },
                      { label: 'Complaint Address', icon: 'mdi:home-map-marker', value: formData.complaint_address },
                      { label: 'Received By', icon: 'mdi:account', value: formData.received_by },
                    ].map(({ label, icon, value }, index) => (
                      <div key={index} className="d-flex justify-content-between">
                        <span className="text-success d-flex align-items-center gap-1 col-4 fw-bold">
                          <Icon icon={icon} /> {label}
                        </span>
                        <span className="col-1">:</span>
                        <span className="col-7 text-decoration-underline">{value}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              
              <div className="py-28 px-20">
                <div className="row fs-5">
                  <div className="col-12 mt-3">
                    <h6 className="mb-3 text-success d-flex align-items-center gap-1 col-4 fw-bold">
                      <Icon icon="mdi:clipboard-text" />Complaint Details
                    </h6>
                    <p>{formData.complaint_detail || 'No Data Found'}</p>
                  </div>
                </div>
              </div>
              
              <hr/>
              
              <div className="py-28 px-20">
                <div className="row fs-5">
                  <div className="col-12 mt-3">
                    <h6 className="mb-3 text-success d-flex align-items-center gap-1 col-4 fw-bold">
                      <Icon icon="mdi:text" />Additional Remarks
                    </h6>
                    <p>{formData.complaint_additional_remarks || 'No Data Found'}</p>
                  </div>
                </div>
              </div>
              
              <hr/>

              {formData.status === 'Closed' && latestStatusHistory && (
                <div className="py-28 px-20">
                  <div className="row fs-5">
                    <div className="col-12 mt-3">
                      <h6 className="mb-3 text-success d-flex align-items-center gap-1 col-4 fw-bold">
                        <Icon icon="mdi:clipboard-check-outline" />Complain Closing Details
                      </h6>
                      <div className="space-y-2">
                        {[
                          { label: 'Closed By', icon: 'mdi:account', value: latestStatusHistory.by || 'No Data Found' },
                          // Officer name & contact intentionally hidden.
                          // { label: 'Officer Name', icon: 'mdi:account-tie', value: latestStatusHistory.name || 'No Data Found' },
                          // { label: 'Officer Contact #', icon: 'mdi:phone', value: latestStatusHistory.phoneNo || 'No Data Found' },
                          { label: 'Email', icon: 'mdi:email', value: latestStatusHistory.dfoEmail || latestStatusHistory.email || 'No Data Found' },
                          { 
                            label: 'Closure Evidence',
                            icon: 'mdi:paperclip', 
                            value: latestStatusHistory.userMediaArray?.length > 0 ? (
                              <button
                                className="btn btn-sm btn-success-600 mx-20"
                                onClick={() => setShowClosingEvidenceModal(true)}
                                data-bs-toggle="modal"
                                data-bs-target="#closingEvidenceModal"
                              >
                                Show Attachments
                              </button>
                            ) : 'No Attachment Available'
                          },
                          { label: 'Remarks', icon: 'mdi:comment-text', value: latestStatusHistory.userRemarks || latestStatusHistory.dfo_remarks || 'No Data Found' },
                        ].map(({ label, icon, value }, index) => (
                          <div key={index} className="d-flex justify-content-between">
                            <span className="text-success d-flex align-items-center gap-1 col-4 fw-bold">
                              <Icon icon={icon} /> {label}
                            </span>
                            <span className="col-1">:</span>
                            <span className="col-7 text-decoration-underline">{value}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              )}
              
              <hr/>

              <div className="py-28 px-20">
                <div className="row fs-5">
                  <div className="col-md-6">
                    <h6 className="text-md mb-3">Complainant Information:</h6>
                    <div className="space-y-2">
                      {[
                        { label: 'Name', icon: 'mdi:account', value: formData.complainant_name },
                        { label: 'Phone Number', icon: 'mdi:phone', value: formData.complainant_contact_no },
                        { label: 'Email', icon: 'mdi:email', value: formData.complainant_email },
                        { label: 'Phone Secondary', icon: 'mdi:phone', value: formData.complainant_phone_secondry },
                        { label: 'CNIC', icon: 'mdi:id-card', value: formData.cnic },
                      ].map(({ label, icon, value }, index) => (
                        <div key={index} className="d-flex mb-2">
                          <div className="col-4 fw-bold text-success d-flex align-items-center gap-1">
                            <Icon icon={icon} /> {label}
                          </div>
                          <div className="col-1 text-center">:</div>
                          <div className="col-7 text-decoration-underline">{value}</div>
                        </div>
                      ))}
                    </div>
                  </div>

                  <div className="col-md-6">
                    <h6 className="text-md mb-3">Complainant Address:</h6>
                    <div className="space-y-2">
                      {[
                        { label: 'Address', icon: 'mdi:home', value: formData.complainant_address },
                        { label: 'Tehsil', icon: 'mdi:map', value: formData.complainant_tehsil },
                        { label: 'District', icon: 'mdi:map', value: formData.complainant_district },
                      ].map(({ label, icon, value }, index) => (
                        <div key={index} className="d-flex mb-2">
                          <div className="col-4 fw-bold text-success d-flex align-items-center gap-1">
                            <Icon icon={icon} /> {label}
                          </div>
                          <div className="col-1 text-center">:</div>
                          <div className="col-7 text-decoration-underline">{value}</div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>

                <div className="mt-24">
                  <div className="scroll-sm">
                    <form onSubmit={handleSubmit}>
                      <div>
                        <div className="mb-4">
                          <div className="text-lg font-semibold">Analyze Complaint</div>
                          <hr className="my-3" />
                          
                          <div className="row gy-3">
                            <div className="col-lg-4 col-md-6 col-sm-12 mb-4">
                              <label className="form-label d-flex align-items-center gap-2" htmlFor="complaintAction">
                                <Icon icon="mdi:clipboard-check" className="text-lg" />
                                Complaint Action
                              </label>
                              <select
                                id="complaintAction"
                                name="complaintAction"
                                value={formDataForest.complaintAction}
                                onChange={handleChange}
                                className="form-select"
                                required
                                disabled={isSubmitting}
                              >                                
                                <option value="Resolve">Resolve Complaint</option>
                                <option value="Re-Open">Re-Open Complaint</option>
                              </select>
                            </div>

                            {formDataForest.complaintAction === 'Resolve' && (
                              <div className="col-lg-12 col-md-12 col-sm-12 mb-4">
                                <label className="form-label d-flex align-items-center gap-2" htmlFor="closeRemarks">
                                  <Icon icon="mdi:comment-text" className="text-lg" />
                                  Remarks <span className="text-danger">*</span>
                                </label>
                                <textarea
                                  id="closeRemarks"
                                  name="closeRemarks"
                                  value={formDataForest.closeRemarks}
                                  onChange={handleChange}
                                  className="form-control"
                                  rows="4"
                                  placeholder="Enter remarks for resolving the complaint"
                                  required
                                  disabled={isSubmitting}
                                />
                              </div>
                            )}

                            {formDataForest.complaintAction === 'Re-Open' && (
                              <>
                                <div className="col-lg-12 col-md-12 col-sm-12 mb-4">
                                  <label className="form-label d-flex align-items-center gap-2" htmlFor="reopenRemarks">
                                    <Icon icon="mdi:comment-text" className="text-lg" />
                                    Reopen Remarks <span className="text-danger">*</span>
                                  </label>
                                  <textarea
                                    id="reopenRemarks"
                                    name="reopenRemarks"
                                    value={formDataForest.reopenRemarks}
                                    onChange={handleChange}
                                    className="form-control"
                                    rows="4"
                                    placeholder="Enter remarks for re-opening the complaint"
                                    required
                                    disabled={isSubmitting}
                                  />
                                </div>

                                {/* Optional attachment(s) with the re-open remarks */}
                                <div className="col-lg-12 col-md-12 col-sm-12 mb-4">
                                  <label className="form-label d-flex align-items-center gap-2">
                                    <Icon icon="mdi:file-upload" className="text-lg" />
                                    Attachment <span className="text-secondary-light">(optional)</span>
                                  </label>
                                  <ComplaintUploadWithImagePreviewList
                                    onFileUploadSuccess={(url) => {
                                      setReopenMediaUrls((prev) => [...prev, url]);
                                    }}
                                  />
                                  <label className="text-sm mt-1 mb-0">Optional — upload up to 5 files (PDF, Word or JPG, max 5 MB).</label>
                                </div>

                                <div className="col-lg-12 col-md-12 col-sm-12 mb-4">
                                  <div className="card border-0 shadow-sm">
                                    <div className="card-header bg-success-700 text-white">
                                      <h6 className="mb-0 d-flex align-items-center gap-2 text-white">
                                        <Icon icon="mdi:account-multiple-check" />
                                        Officer Checklist
                                        <span className="text-warning ms-2">*</span>
                                      </h6>
                                      <small className="text-warning">Select only one officer at a time</small>
                                    </div>
                                    <div className="card-body">
                                      <div className="row g-3">
                                        {Object.entries(officerConfig).map(([officerKey, officer]) => (
                                          <div key={officerKey} className="col-lg-3 col-md-4 col-sm-6">
                                            <div className={`form-check card border h-100 ${officerChecklist[officerKey] ? 'border-success bg-success-50' : ''}`}>
                                              <div className="card-body p-3">
                                                <input
                                                  className="form-check-input"
                                                  type="radio"
                                                  name="officerSelection"
                                                  id={`officer-${officerKey}`}
                                                  checked={officerChecklist[officerKey]}
                                                  onChange={() => handleChecklistChange(officerKey)}
                                                  disabled={isSubmitting}
                                                />
                                                <label 
                                                  className="form-check-label d-flex align-items-center gap-2 w-100 h-100" 
                                                  htmlFor={`officer-${officerKey}`}
                                                  style={{ cursor: 'pointer' }}
                                                >
                                                  <Icon 
                                                    icon={officer.icon} 
                                                    className={`text-${officerChecklist[officerKey] ? 'success' : 'muted'}`}
                                                    style={{ fontSize: '1.5rem' }}
                                                  />
                                                  <div>
                                                    <span className={`d-block ${officerChecklist[officerKey] ? 'fw-bold text-success' : 'text-muted'}`}>
                                                      {officer.label}
                                                    </span>
                                                  </div>
                                                </label>
                                              </div>
                                            </div>
                                          </div>
                                        ))}
                                      </div>

                                      {(officerChecklist.DFO || officerChecklist.CF || officerChecklist.CCF) && (
                                        <div className="mt-3">
                                          <label className="form-label" htmlFor="selectedOfficerId">
                                            Select {officerChecklist.DFO ? "DCF" : officerChecklist.CF ? "CF" : "CCF"}
                                            <span className="text-danger ms-1">*</span>
                                          </label>
                                          <select
                                            id="selectedOfficerId"
                                            className="form-select"
                                            value={selectedOfficerId}
                                            onChange={(event) => setSelectedOfficerId(event.target.value)}
                                            disabled={isSubmitting || isLoadingOfficers}
                                            required
                                          >
                                            <option value="">
                                              {isLoadingOfficers ? "Loading officers..." : "Select an officer"}
                                            </option>
                                            {reopenOfficers.map((officer) => (
                                              <option key={officer._id} value={officer._id}>
                                                {officer.designation || ""}
                                              </option>
                                            ))}
                                          </select>
                                          {!isLoadingOfficers && reopenOfficers.length === 0 && (
                                            <small className="text-danger">No officers are available for this type.</small>
                                          )}
                                        </div>
                                      )}
                                      
                                      <div className="mt-3 p-3 bg-light rounded">
                                        <div className="d-flex align-items-center gap-2 mb-2">
                                          <Icon icon="mdi:information-outline" className="text-info" />
                                          <small className="text-muted">
                                            Selected officer: {Object.entries(officerChecklist)
                                              .filter(([_, isChecked]) => isChecked)
                                              .map(([officerKey]) => officerConfig[officerKey].label)
                                              .join(', ') || 'None'}
                                          </small>
                                        </div>
                                        {Object.values(officerChecklist).filter(Boolean).length === 0 && (
                                          <small className="text-danger">
                                            <Icon icon="mdi:alert-circle" className="me-1" />
                                            Please select one officer
                                          </small>
                                        )}
                                        {Object.values(officerChecklist).filter(Boolean).length > 1 && (
                                          <small className="text-danger">
                                            <Icon icon="mdi:alert-circle" className="me-1" />
                                            Only one officer can be selected at a time
                                          </small>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="d-flex justify-content-end">
                        <button
                          className="btn btn-success btn-sm px-6 py-12 radius-12 my-24 mx-10 col-lg-2 col-md-4 col-sm-12"
                          type="submit"
                          disabled={
                            isSubmitting ||
                            (formDataForest.complaintAction === 'Re-Open' &&
                              (Object.values(officerChecklist).filter(Boolean).length !== 1 ||
                                ((officerChecklist.DFO || officerChecklist.CF || officerChecklist.CCF) && !selectedOfficerId)))
                          }
                        >
                          {isSubmitting ? (
                            <>
                              <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                              {formDataForest.complaintAction === 'Resolve' ? 'Resolving...' : 'Re-Opening...'}
                            </>
                          ) : (
                            formDataForest.complaintAction === 'Resolve' ? 'Resolve Complaint' : 'Re-Open Complaint'
                          )}
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>

              <div className="modal fade" id="attachmentsModal" tabIndex="-1" aria-labelledby="attachmentsModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title" id="attachmentsModalLabel">
                        <Icon icon="mdi:paperclip" className="me-2" /> Complaint Evidence
                      </h5>
                      <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={() => setShowAttachmentsModal(false)}></button>
                    </div>
                    <div className="modal-body">
                      {formData.media_array?.length > 0 ? (
                        <ul className="list-unstyled">
                          {formData.media_array.map((attachment, index) => (
                            <li key={index} className="mb-2">
                              <a
                                href={getMediaUrl(attachment)}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-success-900 text-decoration-underline font-bold"
                              >
                                ({formData.complaint_number})-Attachment-{index + 1}
                              </a>
                            </li>
                          ))}
                        </ul>
                      ) : (
                        <p className="text-muted">No attachments available.</p>
                      )}
                    </div>
                    <div className="modal-footer">
                      <button
                        type="button"
                        className="btn btn-secondary"
                        data-bs-dismiss="modal"
                        onClick={() => setShowAttachmentsModal(false)}
                      >
                        Close
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              {formData.status === 'Closed' && latestStatusHistory && (
                <div className="modal fade" id="closingEvidenceModal" tabIndex="-1" aria-labelledby="closingEvidenceModalLabel" aria-hidden="true">
                  <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h5 className="modal-title" id="closingEvidenceModalLabel">
                          <Icon icon="mdi:paperclip" className="me-2" /> CRO Closure Evidence
                        </h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={() => setShowClosingEvidenceModal(false)}></button>
                      </div>
                      <div className="modal-body">
                        {latestStatusHistory.userMediaArray?.length > 0 ? (
                          <ul className="list-unstyled">
                            {latestStatusHistory.userMediaArray.map((attachment, index) => (
                              <li key={index} className="mb-2">
                                <a
                                  href={attachment}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="text-success-900 text-decoration-underline font-bold"
                                >
                                  ({formData.complaint_number})-Closing-Evidence-{index + 1}
                                </a>
                              </li>
                            ))}
                          </ul>
                        ) : (
                          <p className="text-muted">No closing evidence available.</p>
                        )}
                      </div>
                      <div className="modal-footer">
                        <button
                          type="button"
                          className="btn btn-secondary"
                          data-bs-dismiss="modal"
                          onClick={() => setShowClosingEvidenceModal(false)}
                        >
                          Close
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ComplainFormPageCloseUpdate;
